<customer-search
  [dialogMode]="dialogMode"
  [autocomplete]="auto"
  [placeholder]="'i18n.Common.searchPlant' | translate"
  [query]="query"
  (queryChange)="query$.next($event)">
</customer-search>

<mat-autocomplete
  #auto="matAutocomplete"
  class="custom-search-autocomplete p-0 {{ dialogMode ? 'custom-search-dialog-width' : '' }}">
  <ng-container
    *ngIf="{
      systems: filteredSystems$ | async,
      devices: filteredDevices$ | async
    } as filteredData">
    <div
      *ngIf="filteredData.systems?.length || filteredData.devices?.length"
      class="py-2 px-3">
      <div
        *ngIf="filteredData.systems?.length"
        class="fx-row fx-justify-start fx-align-center text-grey-400 tw-text-base tw-font-normal h-9">
        {{ 'i18n.Common.plants' | translate }}
      </div>
      <mat-option
        *ngFor="let option of filteredData.systems"
        class="radius-4 hover py-1 px-2 min-h-8 h-8 autocomplete"
        mat-dialog-close
        [routerLink]="['/customer/plants', option.uid]"
        [value]="option.name">
        <div class="fx-row fx-justify-between fx-align-center text-grey-400 fx-gap-3">
          <div class="fx-row fx-justify-start fx-align-center ellipsed fx-gap-3">
            <div class="fx-row fx-gap-2 fx-center">
              <mat-icon
                *ngIf="option.source === 'aws'"
                class="s-6 m-0"
                svgIcon="block_verified">
              </mat-icon>
              <mat-icon
                class="s-6 m-0"
                [svgIcon]="option.configuration.connextId ? 'customer_connext' : option.configuration.azzurroHubId ? 'customer_azzurro_hub' : 'customer_stick_logger'">
              </mat-icon>
            </div>
            <span class="ellipsed tw-text-base tw-font-light tw-tabular-nums">
              {{ option.name | uppercase }}
            </span>
          </div>
          <span class="tw-text-sm tw-font-medium text-nowrap">
            {{ 'i18n.Common.jumpTo' | translate }}
          </span>
        </div>
      </mat-option>
      <mat-option
        *ngIf="showMore$ | async"
        class="radius-4 hover py-1 px-2 min-h-8 h-8 autocomplete"
        mat-dialog-close
        [queryParams]="{ query: query }"
        [routerLink]="['/customer/plants']">
        <div class="fx-row fx-justify-between fx-align-center text-grey-400 fx-gap-3">
          <div class="fx-row fx-justify-start fx-align-center ellipsed fx-gap-3">
            <span class="ellipsed tw-text-sm tw-font-medium tw-tabular-nums">
              {{ 'i18n.Common.showMore' | translate }}
            </span>
          </div>
          <span class="tw-text-sm tw-font-medium text-nowrap">
            {{ 'i18n.Common.jumpTo' | translate }}
          </span>
        </div>
      </mat-option>

      <hr
        *ngIf="filteredData.systems?.length && filteredData.devices?.length"
        class="bg-grey-300 my-2">

      <div
        *ngIf="filteredData.devices?.length"
        class="fx-row fx-justify-start fx-align-center text-grey-400 tw-text-base tw-font-normal h-9">
        {{ 'i18n.Common.devices' | translate }}
      </div>
      <mat-option
        *ngFor="let option of filteredData.devices"
        class="radius-4 hover py-1 px-2 min-h-13 h-13 autocomplete"
        mat-dialog-close
        [routerLink]="['/customer/plants', option.system.uid, 'devices']"
        [value]="option.device.id">
        <div class="fx-row fx-justify-between fx-align-center text-grey-400 fx-gap-3">
          <div class="fx-row fx-justify-start fx-align-center ellipsed fx-gap-3">
            <mat-icon
              class="s-6 m-0"
              [svgIcon]="option.device.id | apply : getDeviceIconIdentifier">
            </mat-icon>
            <div class="fx-col ellipsed tw-tabular-nums">
              <span class="ellipsed tw-text-base tw-font-light">
                {{ option.device.id | uppercase }}
              </span>
              <span class="ellipsed tw-text-sm tw-font-medium">
                {{ option.system.name | uppercase }}
              </span>
            </div>
          </div>
          <span class="tw-text-sm tw-font-medium text-nowrap">
            {{ 'i18n.Common.jumpTo' | translate }}
          </span>
        </div>
      </mat-option>
    </div>
  </ng-container>
</mat-autocomplete>
